<template>
    <el-dialog class="dialog dialog-mini" :visible="dialogs.user" customClass="dialog_main dialog-mini_main" :append-to-body="true" @open='handleOpen' :close-on-click-modal="false" @close="closeDialog()">
        <div slot="title" class="dialog__head dialog__head_second">
            <div class="dialog__head-inner mb-24">
                <h3 class="dialog__title">Создание пользователя</h3>
            </div>
            <div class="divider"></div>
        </div>

        <div slot="default" class="dialog__inner">
            <form class="search-form" @submit.prevent="submitSelected">
                <div class="dialog__content">
                    <template v-if="user.role_id === 1">
                        <label class="dialog__label">Укажите роль пользователя</label>

                        <ul class="entry-list dialog__content-blocks mt-12 mb-24">
                            <li class="entry-list__item career-trajectory-page__list-item-clickable" v-for="item in rolesInDialog" :key="item.id" :class="{ 'career-trajectory-page__list-item_active': activeEl === item.id }" @click="activeEl = item.id">
                                <div class="entry entry_48-height">
                                    <div class="entry__inner">
                                        <div class="entry__item">
                                            <p class="career-trajectory-page__list-item-text">{{ item.name }}</p>
                                        </div>
                                        <div class="career-trajectory-page__icon_success entry__item" v-if="activeEl === item.id">
                                            <icon-base width="14" height="10" viewBox="0 0 12 10"><icon-success /></icon-base>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </template>

                    <validate-input v-model="name" name="name" placeholder="ФИО" type="text" v-bind:error="nameError" v-on:update:error="nameError = $event" :validateOptions="['empty']" />

                    <v-select v-if="activeUser.id && user.role_id === 1" class="select mt-8" name="spk_id" placeholder="Организация" label="name" v-model="org" :clearable="false" :options="spk">
                        <template #no-options="{ search, searching, loading }">
                            {{ SELECT_NOT_FOUND }}
                        </template>
                        <template #open-indicator="{ attributes }">
                            <span v-bind="attributes">
                                <icon-base width="14" height="8" viewBox="0 0 14 8" iconColor="#000"><icon-arrow-down /></icon-base>
                            </span>
                        </template>
                    </v-select>

                    <input v-else-if="activeSPKId !== null" type="text" name="spk_id" class="input mt-8" placeholder="Организация" :value="spk.find(el => el.id === activeSPKId).name" readonly required>

                    <validate-input class="mt-8" name="email" v-model="email" placeholder="Почта" type="email" v-bind:error="emailError" v-on:update:error="emailError = $event" :validateOptions="['empty', 'email']" />

                    <masked-input name="phone" mask="\+\7 (111) 111-11-11" class="input mt-8" placeholder="Телефон" :class="{'input_error': phoneError}" v-model="phone" />

                    <validate-input class="mt-8" v-model="userPassword" v-bind:error="userPasswordError" v-on:update:error="userPasswordError = $event" type="password" name="password" placeholder="Введите новый пароль" :validateOptions="['password']" :validateString="userPasswordConfirm" />

                    <validate-input class="mt-8" v-model="userPasswordConfirm" v-bind:error="userPasswordError" v-on:update:error="userPasswordError = $event" type="password" name="confirm_password" placeholder="Повторите новый пароль" :validateOptions="['password']" :validateString="userPassword" />
                </div>

                <footer slot="footer" class="dialog__footer mt-24">
                    <div class="dialog__footer-inner">
                        <div class="dialog__footer-item">
                            <button type="button" class="btn" @click="closeDialog">Отменить</button>
                        </div>
                        <div class="dialog__footer-item">
                            <button type="submit" class="btn btn_action" :disabled="activeEl === null || !name.length || !email.length || emailError || !userPassword.length || !userPasswordConfirm.length || userPasswordError || (activeSPKId === null ? !org : false) || !phone.length || phoneError">{{ activeUser.id ? 'Редактировать пользователя' : 'Создать пользователя' }}</button>
                        </div>
                    </div>
                </footer>
            </form>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';

import dialog from '@/mixins/dialog';
import ValidateInput from '@/components/ValidateInput'
import MaskedInput from 'vue-masked-input';

export default {
    mixins: [ dialog ],
    components: {
        MaskedInput,
        ValidateInput
    },
    props: {
        activeUser: {
            type: Object,
            default: function() {
                return {}
            }
        },
        activeSPKId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            activeEl: null,
            email: '',
            name: '',
            org: null,
            phone: '',
            userPassword: '',
            userPasswordConfirm: '',
            userPasswordError: false,
            emailError: false,
            nameError: false,
            phoneError: false,
            emailErrorText: '',
            rolesInDialog: [
                {
                    name: 'Администратор',
                    id: 0
                },
                {
                    name: 'Разработчик',
                    id: 1
                },
            ]
        }
    },
    methods: {
        ...mapActions('user', ['CREATE_USER', 'UPDATE_CURRENT_USER']),
        ...mapActions('tokens', ['LOGIN']),
        ...mapMutations('common', ['TOGGLE_ALERT']),

        closeDialog() {
            this.activeEl = null
            this.email = ''
            this.name = ''
            this.org = ''
            this.phone = ''
            this.emailError = false
            this.nameError = false
            this.phoneError = false

            this.elDialogs.user = false;
        },
        handleOpen() {
            if (this.activeUser.id) {
                this.email = this.activeUser.email
                this.name = this.activeUser.name
                this.org = this.spk.find(el => el.id === this.activeUser.spk_id)
                this.phone = this.activeUser.phone
                this.activeEl = this.activeUser.role_id === 1 || this.activeUser.role_id === 2 || this.activeUser.role_id == 4 ? 0 : 1
            } else 
            
            if (this.user.role_id == 2) this.activeEl = 1
            else if (this.user.role_id == 4) this.activeEl = 1
            else if (this.user.role_id == 1) this.activeEl = 1
        },
        async submitSelected(e) {
            const formData = new FormData(e.target);

            let params = {}

            for (const pair of formData.entries()) {
                params[pair[0]] = pair[1];
            }

            if (this.activeUser.id) {
                let spk_id = ''
                if (this.activeUser.id && this.user.role_id === 1) spk_id = this.org.id
                else if (this.activeSPKId !== null) spk_id = this.spk.find(el => el.id === this.activeSPKId).id
                else spk_id = this.org.id

                let role_id = ''
                if (this.activeSPKId !== null) role_id = this.spk.find(el => el.id === this.activeSPKId).is_spk === 1
                                                            ? (this.activeEl === 0 ? 2 : 3)
                                                            : (this.activeEl === 0 ? 4 : 5)
                else role_id = this.spk.find(el => el.id === this.activeSPKId).is_spk === 1
                        ? (this.activeEl === 0 ? 2 : 3)
                        : (this.activeEl === 0 ? 4 : 5)

                let spk_name =  this.spk.find(el => el.id === this.activeSPKId).name;

                params = Object.assign(params, {
                    role_id,
                    spk_id,
                    spk_name
                })

                const data = {
                    userId: this.activeUser.id,
                    params
                }

                await this.UPDATE_CURRENT_USER(data).then(status => {
                    if (status === 202 ) {
                        this.userPassword = ''
                        this.userPasswordConfirm = ''
                        this.userPasswordError = false
                        this.closeDialog()
                    } else if (status === 422) {
                        this.TOGGLE_ALERT({open: true, text: 'Пользователь с такой почтой уже существует'})
                    } else {
                        this.TOGGLE_ALERT({open: true, text: 'Проверьте почту и попробуйте ещё раз'})
                    }
                })
            } else {
                let spk_id = ''
                if (this.activeSPKId !== null) spk_id = this.spk.find(el => el.id === this.activeSPKId).id
                else spk_id = this.org.id

                let role_id = ''
                if (this.activeSPKId !== null) role_id = this.spk.find(el => el.id === this.activeSPKId).is_spk === 1
                                                            ? (this.activeEl === 0 ? 2 : 3)
                                                            : (this.activeEl === 0 ? 4 : 5)
                else role_id = this.spk.find(el => el.id === this.activeSPKId).is_spk === 1
                        ? (this.activeEl === 0 ? 2 : 3)
                        : (this.activeEl === 0 ? 4 : 5)

                let spk_name =  this.spk.find(el => el.id === this.activeSPKId).name;

                params = Object.assign(params, {
                    role_id,
                    spk_id,
                    spk_name
                })

                await this.CREATE_USER(params).then(status => {
                    if (status === 201) {
                        this.closeDialog()
                    } else if (status === 422) {
                        this.TOGGLE_ALERT({open: true, text: 'Пользователь с такой почтой уже существует'})
                    } else {
                        this.TOGGLE_ALERT({open: true, text: 'Проверьте почту и попробуйте ещё раз'})
                    }
                })
            }
        }
    },
    computed: {
        ...mapState('user', ['user', 'roles']),
        ...mapState('spk', ['spk']),
    },
    watch: {
        phone: function(val) {
            if (!val) this.phoneError = true
            else if (val.includes('_')) this.phoneError = true
            else this.phoneError = false
        }
    },
    created() {
        this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    }
}
</script>
